<template>
  <div class="text-dark-gray flex h-full flex-col items-center justify-center">
    <WallPaper wallpaper="https://picsum.photos/200/300"></WallPaper>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'default',
})
</script>
